// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    font-weight: 500;
}

:host ::ng-deep .panel-heading {
    border: 1px solid #7A2DF9;
    background: #F7F3FF;
    padding: 0;
    border-radius: 10px 10px 0 0;
}

:host ::ng-deep .panel {
    border-radius: 10px;
}

:host ::ng-deep .panel-default {
    border: 1px solid #E8E8E8;
}

:host ::ng-deep .panel-body {
    padding: 12px 12px 0;
}

::ng-deep .analytics-modal .mat-dialog-container {
    background: #f8fafb;
    margin-block: 30px !important;
    position: relative;
    height: calc(100vh - 50px);
}

.grabbable {
    cursor: move;
    cursor: grab;
    cursor: -webkit-grab;
}

.grabbable:active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

.civ-paths-btn {
    display: inline-flex;
    align-items: center;
    background: rgba(100, 56, 180, 0.05);
    border: 1px solid #6438B4;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    color: #6438B4;
    padding: 0 16px;
    margin: 5px 10px 5px 0;
    min-height: 44px;
}

.civ-paths-btn:hover {
    background: rgba(100, 56, 180, 0.15);
}

.cursor {
    cursor: pointer;
}

.poster-img {
    border-radius: 10px;
}

.heading-accordion {
    color: black;
    font-weight: 500;
    font-size: 15px;
}

.active {
    color: #7A2DF9 !important;
}

.arrow-icon {
    color: #7A2DF9;
}

.accordion-option {
    font-size: 15px;
    color: #797979;
    padding-bottom: 12px;
}

.chart-container {
    width: 100%;
    height: 200px;
    background: #fff;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    padding: 10px;
}

.days-btn {
    border: none;
    outline: none;
    background: #6c2fbb;
    color: white;
    font-size: 12px;
    border-radius: 4px;
}

.most-common-choices {
    border: 1px solid rgba(0,0,0,.125);
    border-radius: 6px;
    color: #6c2fbb;
    text-align: center;
    background: #fff;
}

.right-content {
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    padding: 20px;
    background: #fff;
    height: 100%;
}

.time-frame-wrapper {
    width: 90%;
    position: absolute;
    right: 14px;
}

@media (max-width: 991px) {
    .time-frame-wrapper {
        width: 50%;
    }
    .zoom-btn-main {
        text-align: right;
    }
}

.zoom-btn-group .btn {
    background: #fff;
    border: 1px solid lightgrey;
    font-weight: 500;
    font-size: 14px;
    color: #5C5C5C;
    box-shadow: none;
}

#my-chart, #top-choices-chart {
    width: 100% !important;
    height: 100% !important;
}

.btn-close {
    position: absolute;
    right: 2px;
    top: 4px;
}

.viewChoice{
    background: #6c2fbb;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
    padding: 11px 32px;
    gap: 10px;
    width: 100%;
    white-space: nowrap;
    min-width: 240px;
    border: none;
    border-radius: 7px;
}

.btnRefresh{
    border: none;
    color: #6c2fbb;
    font-size: 13px;
    border-radius: 4px;
    padding: 5px 10px;
    text-align: end;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: end;
    gap:4px;
    cursor: pointer;
    width: -moz-fit-content;
    width: fit-content;
    margin-left: auto;
}

.group-detail {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
}

.group-detail img {
    object-fit: contain;
    background: #ededed;
    border-radius: 10px;
    padding: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/new-my-videos/analytics-modal/analytics-modal.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IAEZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAEhB,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,OAAO;IACP,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[":host {\n    font-weight: 500;\n}\n\n:host ::ng-deep .panel-heading {\n    border: 1px solid #7A2DF9;\n    background: #F7F3FF;\n    padding: 0;\n    border-radius: 10px 10px 0 0;\n}\n\n:host ::ng-deep .panel {\n    border-radius: 10px;\n}\n\n:host ::ng-deep .panel-default {\n    border: 1px solid #E8E8E8;\n}\n\n:host ::ng-deep .panel-body {\n    padding: 12px 12px 0;\n}\n\n::ng-deep .analytics-modal .mat-dialog-container {\n    background: #f8fafb;\n    margin-block: 30px !important;\n    position: relative;\n    height: calc(100vh - 50px);\n}\n\n.grabbable {\n    cursor: move;\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.grabbable:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n}\n\n.civ-paths-btn {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(100, 56, 180, 0.05);\n    border: 1px solid #6438B4;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #6438B4;\n    padding: 0 16px;\n    margin: 5px 10px 5px 0;\n    min-height: 44px;\n}\n\n.civ-paths-btn:hover {\n    background: rgba(100, 56, 180, 0.15);\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n.poster-img {\n    border-radius: 10px;\n}\n\n.heading-accordion {\n    color: black;\n    font-weight: 500;\n    font-size: 15px;\n}\n\n.active {\n    color: #7A2DF9 !important;\n}\n\n.arrow-icon {\n    color: #7A2DF9;\n}\n\n.accordion-option {\n    font-size: 15px;\n    color: #797979;\n    padding-bottom: 12px;\n}\n\n.chart-container {\n    width: 100%;\n    height: 200px;\n    background: #fff;\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n    padding: 10px;\n}\n\n.days-btn {\n    border: none;\n    outline: none;\n    background: #6c2fbb;\n    color: white;\n    font-size: 12px;\n    border-radius: 4px;\n}\n\n.most-common-choices {\n    border: 1px solid rgba(0,0,0,.125);\n    border-radius: 6px;\n    color: #6c2fbb;\n    text-align: center;\n    background: #fff;\n}\n\n.right-content {\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n    padding: 20px;\n    background: #fff;\n    height: 100%;\n}\n\n.time-frame-wrapper {\n    width: 90%;\n    position: absolute;\n    right: 14px;\n}\n\n@media (max-width: 991px) {\n    .time-frame-wrapper {\n        width: 50%;\n    }\n    .zoom-btn-main {\n        text-align: right;\n    }\n}\n\n.zoom-btn-group .btn {\n    background: #fff;\n    border: 1px solid lightgrey;\n    font-weight: 500;\n    font-size: 14px;\n    color: #5C5C5C;\n    box-shadow: none;\n}\n\n#my-chart, #top-choices-chart {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.btn-close {\n    position: absolute;\n    right: 2px;\n    top: 4px;\n}\n\n.viewChoice{\n    background: #6c2fbb;\n    font-weight: 600;\n    font-size: 15px;\n    color: #ffffff;\n    padding: 11px 32px;\n    gap: 10px;\n    width: 100%;\n    white-space: nowrap;\n    min-width: 240px;\n    border: none;\n    border-radius: 7px;\n}\n\n.btnRefresh{\n    border: none;\n    color: #6c2fbb;\n    font-size: 13px;\n    border-radius: 4px;\n    padding: 5px 10px;\n    text-align: end;\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    gap:4px;\n    cursor: pointer;\n    width: fit-content;\n    margin-left: auto;\n}\n\n.group-detail {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n}\n\n.group-detail img {\n    object-fit: contain;\n    background: #ededed;\n    border-radius: 10px;\n    padding: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
